import { Component, OnInit, ViewContainerRef } from '@angular/core';
// import { data } from './datasource';
import { DataUtil } from '@syncfusion/ej2-data';

import { ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"
import { DemoService } from '../../../demo.service';
// import { DataService } from './data.service';

// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, SelectionService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);

import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import {  IFilter } from '@syncfusion/ej2-angular-grids';
import {  ToolbarItems, GroupSettingsModel,
RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { RuleModel } from '@syncfusion/ej2-angular-querybuilder';

import { QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { DataManager, Query, ODataAdaptor, Predicate, ReturnOption } from '@syncfusion/ej2-data';
// import { isNullOrUndefined } from 'util';

import {Brand} from './../../../shared/models/brand.model';
import { Job } from '../../../shared/models/job.model';
import { JobSubject } from '../../../shared/models/jobSubject.model';
import { SearchSubject } from '../../../shared/models/searchSubject.model';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';


import { filter } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { HotToastService } from '@ngneat/hot-toast';
import { MysqlService } from './../../../services/mysql.service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { LegalDateTimeService } from './../../../services/legal-datetime.service';


// Set Syncfuion Culture and Internationalization
import { Internationalization } from '@syncfusion/ej2-base';
import {setCulture} from '@syncfusion/ej2-base';
// setCulture('au');
import { setCurrencyCode} from '@syncfusion/ej2-base';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { isNullOrUndefined } from 'util';
setCurrencyCode('AUD');




@Component({
  selector: 'app-jobs-subjects-created-report',
  templateUrl: './jobs-subjects-created-report.component.html',
  styleUrls: ['./jobs-subjects-created-report.component.css'],
  providers: [ToolbarService, PdfExportService, PageService, FilterService, SortService]
})
export class JobsSubjectsCreatedReportComponent implements OnInit {


  public data: Object[] = [{ x: 'WW', y: 38.3, text: 'World Wide' },
  { x: 'EU', y: 45.2, text: 'Europe' },
  { x: 'APAC', y: 18.2, text: 'Asia Pacific' },
  { x: 'LATAM', y: 46.7, text: 'Latin America' },
  { x: 'MEA', y: 61.5, text: 'Middle East Africa' },
  { x: 'NA', y: 64, text: 'North America' }];

  //Initializing Primary X Axis
public primaryXAxis: Object = {
  valueType: 'Category',
};


  public items: object[];
  subjects_urgent: any;
  subjects_results: any;
  subjects_urgent1: Object;

public query_b_data: Object[];
public importRules: RuleModel;
public values: string[] = ['Mr.', 'Mrs.'];


@ViewChild('querybuilder') qryBldrObj: QueryBuilderComponent;
@ViewChild('grid') grid: GridComponent;

combo_model: Brand;
  brands_client: any;
  brands_agent: any;
  search_model: any;

  // maps the appropriate column to fields property
// public fields: Object = { text: 'Game', value: 'Id' };
public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  DialogObj: any;

  
  today = new Date();
  toolbarOptions: (string | { text: string; tooltipText: string; prefixIcon: string; id: string; })[];
  initialPage: { pageSize: number; };
  filterOptions: { type: string; };
  groupOptions: { columns: string[]; };
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  filter: { params: { format: any; }; };
  search_results: any;
  pageOptions: { pageSize: number; };
  new_results: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  valueDatePickerDate: Date;
  valueDatePickerDate2: Date;
  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
  subjects_urgent_agent: any;
  subjects_urgent_user: any;
users: any;

baseUploadURL = this.gfunc.baseUploadURL; // all templates reside in the same directory.
baseUploadURLOriginalWordTemplates = this.gfunc.baseUploadURLOriginalWordTemplates;
baseUploadURLEmailTemplates = this.gfunc.baseUploadURLEmailTemplates; // all templates reside in the same directory.
  job_types: any;
  job_status_run: any;
  job_status_data: any;

 constructor(
  private _demoService: DemoService,
  private route: ActivatedRoute, private router: Router,
  private http: HttpClient,
  public datepipe: DatePipe,
  public toastr: HotToastService,
  vcr: ViewContainerRef,
  private _mysqlService: MysqlService, 
  public gfunc: GlobalFunctionsService,
  public legalDate: LegalDateTimeService
 ) {
 
  // Loads local items from JSON
  // this.items = new DataManager(data as JSON[]).executeLocal(new Query().take(6));
       // Set and Access login Session Variables
       this.gfunc.setLoginSessionVars(); // set in a global function file
       this.sessionUserId = this.gfunc.currentUserVAR.user_id;
       this.sessionUsername = this.gfunc.currentUserVAR.username;
       this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
      
            // need to add this as routes does not work globally
            this.all_router_details = this.router.url;
            this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
      
         //   this.toastr.setRootViewContainerRef(vcr);
      // Date picker date format
       //  this.valueDatePickerDate = new Date(this.today);
         this.valueDatePickerDate = this.removeDays(90);


  }

  ngAfterViewInit() {
    let intl: Internationalization = new Internationalization();
    let dFormatter: Function = intl.getDateFormat({ skeleton: 'short', type: 'dateTime' });
  //  let formattedString: string = dFormatter(new Date('1/12/2014 10:20:33'));

    }


  public ngOnInit(): void {

    // { text: ' >: Filter Agents For Update Request',
    // tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Click'  }

    this.toolbarOptions = ['ExcelExport', 'Search'];
   // this.toolbar = [
   // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

  this.initialPage = { pageSize:10 };
   this.filterOptions = {
      type: 'Menu'
   };
  this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
   this.dateFormat = 'dd/MM/yyyy hh:mm a';
   this.filter = { params: { format: this.dateFormat } };
  this.pageOptions = { pageSize: 100 }; 



  // :: Turned off on inital load to force the use of date fields
   // this.getJobSubjectsUrgentTable(); // also loads data locally into grid through DataManager so that I can Queriy.
   
    //:: TODO @ need to create a new model for the search fields in the 
    this.search_model = new SearchSubject();
   
    // Combo Box Options
this.combo_model = new Brand(); // loads the Trace model into the model vars for the form.
this.getBrandsComboBoxClients(this.combo_model);
this.getBrandsComboBoxAgents(this.combo_model);
this.getUsers();
this.getJobTypes();
this. getJobStatusNames();

    this.query_b_data = this.items;
    this.importRules = {
    'condition': 'or',
    'rules': [{
            'label': 'Subject ID',
            'field': 'subject_id',
            'type': 'number',
            'operator': 'equal',
            'value': 303
        },
        {
            'label': 'Subject Name',
            'field': 'subject_name',
            'type': 'string',
            'operator': 'equal',
            'value': 'Mr Josh Mosh'
        }]
    };


  } //

  getJobSubjectsUrgentTable() {
    this._demoService.getJobSubjectsUrgentTable().subscribe(
      data => { this.subjects_urgent1 = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data); 
        this.subjects_results = DataUtil.parse.parseJson(data); 
       // console.log("Done loadng USER");
        console.log(data);

       this.items = new DataManager(data as JSON[]).executeLocal(new Query().take(1000));
     
       // :: This section allow to hard code predicate filters before loading data in to DataManager

        // let predicate: Predicate = new Predicate('subject_name', 'equal', 'Mr Josh Mosh');
        // predicate = predicate.or('subject_id', 'equal', 303);
        // this.items =  new DataManager(this.subjects_urgent).executeLocal(new Query().where(predicate).take(8));
  
      },
      error => {
      console.error('Error Loading !' + error.error);
      //return Observable.throw(error);
      }
    ); }
  

    getJobSubjectsUrgentTableSearch(search_model) {

      search_model.assigned_agent = null;
      search_model.created_by = null;
      this._demoService.getJobSubjectsUrgentTableSearchReporting(search_model).subscribe(
        data => { this.subjects_urgent1 = data;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          
          // Might Need to Pass the dates first Like I do with dubjects urgetn to get them to display correctly?? -- Had to do this to get update_date to display
          this.subjects_urgent = DataUtil.parse.parseJson(data); 
          this.subjects_urgent.forEach(element => {
            // Date Formatting (Before Load)
            // see: https://stackoverflow.com/questions/40377103/how-to-convert-date-into-this-yyyy-mm-dd-format-in-angular-2
            element.created_date  =  this.datepipe.transform(element.created_date, 'dd/MM/yyyy h:mm a');
            element.updated_date  =  this.datepipe.transform(element.updated_date, 'dd/MM/yyyy h:mm a');
            // element.hearing_date  =  this.datepipe.transform(element.hearing_date, 'dd/MM/yyyy h:mm a');
            // element.judgement_date  =  this.datepipe.transform(element.judgement_date, 'dd/MM/yyyy h:mm a');
            // Agents Assigned
            }); // end for each of all

            this.subjects_urgent = this.subjects_urgent;

          // this.subjects_urgent = DataUtil.parse.parseJson(data); 
          // this.subjects_urgent = data; 
          this.subjects_results = DataUtil.parse.parseJson(data); 
         // console.log("Done loadng USER");
          // console.log(data);
  
       //  this.items = new DataManager(data as JSON[]).executeLocal(new Query().take(1000));
         this.grid.refresh();
       
         // :: This section allow to hard code predicate filters before loading data in to DataManager
  
          // let predicate: Predicate = new Predicate('subject_name', 'equal', 'Mr Josh Mosh');
          // predicate = predicate.or('subject_id', 'equal', 303);
          // this.items =  new DataManager(this.subjects_urgent).executeLocal(new Query().where(predicate).take(8));
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        //return Observable.throw(error);
        }
      ); }




      getJobSubjectsUrgentTableSearchAgent(search_model) {

        search_model.brand_report_id = null;
        search_model.created_by = null;
        this._demoService.getJobSubjectsUrgentTableSearchReporting(search_model).subscribe(
          data => { this.subjects_urgent1 = data;
            // pass so that the dates are correct in Sync
            // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
            this.subjects_urgent_agent = DataUtil.parse.parseJson(data); 
            this.subjects_results = DataUtil.parse.parseJson(data); 
           // console.log("Done loadng USER");
            console.log(data);
    
         //  this.items = new DataManager(data as JSON[]).executeLocal(new Query().take(1000));
           this.grid.refresh();
         
           // :: This section allow to hard code predicate filters before loading data in to DataManager
    
            // let predicate: Predicate = new Predicate('subject_name', 'equal', 'Mr Josh Mosh');
            // predicate = predicate.or('subject_id', 'equal', 303);
            // this.items =  new DataManager(this.subjects_urgent).executeLocal(new Query().where(predicate).take(8));
      
          },
          error => {
          console.error('Error Loading !' + error.error);
          console.log(error);
          //return Observable.throw(error);
          }
        ); }


        getJobSubjectsUrgentTableSearchUser(search_model) {

          search_model.brand_report_id = null;
          search_model.assigned_agent = null;
          this._demoService.getJobSubjectsUrgentTableSearchReporting(search_model).subscribe(
            data => { this.subjects_urgent1 = data;
              // pass so that the dates are correct in Sync
              // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
              this.subjects_urgent_user = DataUtil.parse.parseJson(data); 
              this.subjects_results = DataUtil.parse.parseJson(data); 
             // console.log("Done loadng USER");
              console.log(data);
      
           //  this.items = new DataManager(data as JSON[]).executeLocal(new Query().take(1000));
             this.grid.refresh();
           
             // :: This section allow to hard code predicate filters before loading data in to DataManager
      
              // let predicate: Predicate = new Predicate('subject_name', 'equal', 'Mr Josh Mosh');
              // predicate = predicate.or('subject_id', 'equal', 303);
              // this.items =  new DataManager(this.subjects_urgent).executeLocal(new Query().where(predicate).take(8));
        
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            //return Observable.throw(error);
            }
          ); }
  



      addDays(days : number): Date{
        let futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + days);
        return futureDate;
      }



 


      removeDays(days : number): Date{
        let futureDate = new Date();
        futureDate.setDate(futureDate.getDate() - days);
        return futureDate;
      }

      /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
  };





// :: Action Query Manager to filter results and update the data UI
    filterResults(){
      const predicate: Predicate = this.qryBldrObj.getPredicate(this.qryBldrObj.rule);
      const fltrDataSource: Object[] = [];
     
      let dataManagerQuery: Query;
      if (isNullOrUndefined(predicate)) {
       dataManagerQuery = new Query().select(['subject_id', 'first_name', 'subject_name', 'created_date', 'subject_number']);
      } else {
        dataManagerQuery = new Query().select(['subject_id', 'first_name', 'subject_name', 'created_date', 'subject_number'])
          .where(predicate);
      }
const dataSet: Object[] = [this.subjects_urgent];

      new DataManager(dataSet)
      .executeQuery
      (dataManagerQuery)
        .then((e: ReturnOption) => {
          (<Object[]>e.result).forEach((data2: Object) => {
            fltrDataSource.push(data2);
            console.log(data2);
           });
        });
        if (isNullOrUndefined(predicate)) {
          this.grid.dataSource = this.subjects_urgent;
          this.items = this.subjects_urgent;
          this.grid.refresh();
        }else {
          this.grid.dataSource = fltrDataSource;
          this.grid.refresh();
        
        }

// let new_results =  new DataManager(this.subjects_urgent).executeLocal(new Query().where(predicate).take(18));
// this.grid.dataSource = new_results;
// this.items = new_results;
// this.grid.refresh();
  
// console.log(new_results);

}



getBrandsComboBoxClients(combo_model) {
  this.combo_model.brand_type_id = 2;
 this._demoService.getBrandsComboBox(combo_model).subscribe(
    data => { this.brands_client = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getBrandsComboBoxAgents(combo_model) {
 this.combo_model.brand_type_id = 3;
this._demoService.getBrandsComboBox(combo_model).subscribe(
   data => { this.brands_agent = data; },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}





// syncfusion dialog simple sample
public onOpenDialog = function(event: any): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'New CLient or a Login User',
    content: 'Create New - Not Currently Activated Yet!.',
    okButton: {  text: 'Ok', click: this.okClick.bind(this) },
    cancelButton: {  text: 'Cancel.', click: this.cancelClick.bind(this) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
private okClick(): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.JSON_job);
// this.createJobSubjectsMultiple(this.newSubject);
 this.DialogObj.hide();
}

private cancelClick(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
}


filterMyWay(search_model){
// reduce the the current collection of unmodified data
// post back to the subjects_urgent data collection variable.
//this.subjects_urgent.filter(c => c.brand_report_id === element.brand_report_id);

//console.log(JSON.parse(search_model));


// if (search_model.brand_report_id != null || search_model.brand_report_id != ''  ){
// this.subjects_urgent = this.subjects_results.filter(
//   function(subject) {
//    return subject.brand_report_id == search_model.brand_report_id;
// // this.subject.brand_report_id  = subject.brand_report_id == search_model.brand_report_id;

//   },
// );
// } // end if


this.subjects_urgent = this.subjects_results.filter((subject) => {
  if (search_model.created_date_from) {
    const createdDateFrom = this.legalDate.toAuditStartOfDayIso(search_model.created_date_from);

    if (!createdDateFrom || this.legalDate.compareAudit(subject.created_date, createdDateFrom) === null || this.legalDate.compareAudit(subject.created_date, createdDateFrom)! < 0) {
      return false;
    }
  }

  if (search_model.created_date_to) {
    const createdDateTo = this.legalDate.toAuditEndOfDayIso(search_model.created_date_to);

    if (!createdDateTo || this.legalDate.compareAudit(subject.created_date, createdDateTo) === null || this.legalDate.compareAudit(subject.created_date, createdDateTo)! > 0) {
      return false;
    }
  }

  if (search_model.updated_date_from) {
    const updatedDateFrom = this.legalDate.toAuditStartOfDayIso(search_model.updated_date_from);

    if (!updatedDateFrom || this.legalDate.compareAudit(subject.updated_date, updatedDateFrom) === null || this.legalDate.compareAudit(subject.updated_date, updatedDateFrom)! < 0) {
      return false;
    }
  }

  if (search_model.updated_date_to) {
    const updatedDateTo = this.legalDate.toAuditEndOfDayIso(search_model.updated_date_to);

    if (!updatedDateTo || this.legalDate.compareAudit(subject.updated_date, updatedDateTo) === null || this.legalDate.compareAudit(subject.updated_date, updatedDateTo)! > 0) {
      return false;
    }
  }

  return true;
});

}


getUsers() {
  this._demoService.getUsers().subscribe(
     data => { this.users = data; },
     err => console.error(err),
     () => console.log('done loading users')
   );
 }




toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}



jobLink(job_id) {
  this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
}

jobView(job_id) {
  this.router.navigate(['/admin/jobs/view/' + job_id + '']);
}

subjectEdit(subject_id){
  this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
}


refreshGrid(){ // refresh the databutton
 // this.mapJobTableLive();
// this.getJobSubjectsUrgentTable();
this.getJobSubjectsUrgentTable();

  this.grid.refresh();
};




  // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
  clickHandler(args: ClickEventArgs): void {
    if (args.item.id === 'Click') {

    //  this.grid.showSpinner();

    //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
   //  console.log(args.data.items);
   


    let pdfdata;
    const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
    for (let i = 0; i < query.queries.length; i++) {
      if (query.queries[i].fn === 'onPage') {
        query.queries.splice(i, 1);       // remove page query to get all records
        break;
      }
    }
    const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
      pdfdata = e.result as object[];  // get all filtered records
      const exportProperties = {
        dataSource: pdfdata,
      };
      //console.log(pdfdata.results);
      
     // this.search_results = pdfdata.records; // need this if a grouping is set.
      this.search_results = pdfdata;
      this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
      this.toastr.success( "Press Start To Process Que"); 
     // this.grid.pdfExport(exportProperties);
    }).catch((e) => true);
    }

   //  this.grid.hideSpinner();

}


getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 private getJobStatusNames() {
  this._demoService.getJobStatusNames()
    .subscribe(
      res => {
        this.job_status_run = res
        this.job_status_data = res
      },
      err => console.error(err.status)
    );
}

  }


    // Allows formatting of dates etc...
    export class DatePipeComponent {
      today: number = Date.now();
      fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
    // tslint:disable-next-line:eofline
    }
  
